module.exports = __webpack_public_path__ + "img/footer_facebook.04923511.svg";